import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * NOTE: DO NOT EDIT THIS FILE!!! THIS FILE WAS GENERATED USING THE FOLLOWING COMMAND.
 *
 * `nx generate @miro-site/local-plugins:update-ds-icons`
 */
import React from 'react';
import { addPropsToSVG } from '../helpers/add-props-to-svg';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var _SocialTwitter = function _SocialTwitter(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      fill: "currentColor",
      d: "M7.9186 21c8.3019 0 12.8427-6.9257 12.8427-12.9317 0-.1967 0-.3925-.0132-.5875a9.2208 9.2208 0 0 0 2.2519-2.3526 8.9627 8.9627 0 0 1-2.5925.7151c.9421-.5678 1.6476-1.4616 1.9844-2.5139a9.0096 9.0096 0 0 1-2.8661 1.1032c-.8535-.9138-2.0454-1.4326-3.2911-1.4326-2.4786 0-4.518 2.0536-4.518 4.5492 0 .3462.0393.6914.117 1.0286-3.6274-.183-7.0117-1.9107-9.3025-4.7486-1.1913 2.065-.5749 4.741 1.3974 6.0671a4.4563 4.4563 0 0 1-2.0486-.5689v.0576c.0006 2.1553 1.5231 4.0286 3.6212 4.4553a4.4772 4.4772 0 0 1-2.038.078c.5898 1.8468 2.2906 3.1199 4.2169 3.1563-1.598 1.2646-3.5732 1.9515-5.6056 1.9494a9.1226 9.1226 0 0 1-1.0745-.0656 12.7164 12.7164 0 0 0 6.9186 2.0381",
      style: {
        vectorEffect: 'non-scaling-stroke'
      }
    }), /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeWidth: props.strokeWidth || 1.5,
      d: "M11.9996 12h.0007",
      style: {
        vectorEffect: 'non-scaling-stroke'
      }
    }), /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeWidth: 2,
      d: "M12 11.9999v.0001",
      style: {
        vectorEffect: 'non-scaling-stroke'
      }
    })]
  }));
};

export var SocialTwitter = addPropsToSVG(_SocialTwitter);